import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Pages/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class PagesQueries extends VueCqrs
{
	runRequestPagesPageQueryV1(workspaceId: number, projectId: number)
	{
		const query = q.buildRequestPagesPageQueryV1(workspaceId, projectId);
		this.$query(query);
	}

	runRequestPageEditorPageQueryV1(workspaceId: number, projectId: number, pageId: number)
	{
		const query = q.buildRequestPageEditorPageQueryV1(workspaceId, projectId, pageId);
		this.$query(query);
	}

	runRequestPageViewerPageQueryV1(accessKey: string)
	{
		const query = q.buildRequestPageViewerPageQueryV1(accessKey);
		this.$query(query);
	}
}